export const KM_TO_MILES = 0.621371;

export const INTEGRATION_NOT_RUN = "N/A (not modeled)";
export const INTEGRATION_FOREIGN = "N/A (foreign)";
export const INTEGRATION_ZERO_TIV = "N/A ($0 TIV)";
export const INTEGRATION_NO_MATCH = "N/A (no match)";
